/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCard/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PaymentProviderMethod from 'DesignSystem/PaymentProvider/PaymentProviderMethod/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CreditCard({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content/ChooseAutopaySource/Content/AutopaySourceDetails/CreditCard"
  
}) {
let editAutopayInfoLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'location._id',
})
let editAutopayInfoReceivablePaymentAccountPersonPaymentAccountPayerPersonValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'receivable.payment_account.person_payment_account.payer_person',
})
let editAutopayInfoReceivablePaymentAccountAccountTypeValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'receivable.payment_account.account_type',
})
  return (<React.Fragment
>
<PaymentProviderMethod
  viewPath={`${viewPath}/PaymentProviderMethod`}
 method="card"
 data="edit_autopay_info.location._id"
 locationId={editAutopayInfoLocationIdValueData}
 data="edit_autopay_info.receivable.payment_account.person_payment_account.payer_person"
 person={editAutopayInfoReceivablePaymentAccountPersonPaymentAccountPayerPersonValueData}
 data="edit_autopay_info.receivable.payment_account.account_type"
 paymentAccountType={editAutopayInfoReceivablePaymentAccountAccountTypeValueData}
/>
{children}
</React.Fragment>)
}